import UserImage from "components/commons/UserImage"


export const TopCriticalPatient = ({
    onClick = ()=>{},
    index,
    user,
    eventsCount
}) => {

    return <div key={user.guid} className="card bg-dark bg-opacity-25" onClick={onClick}>
        {/* <div className="card-header">
            #{index + 1}
        </div> */}
        <div className="card-body">
            <div className="row">
                <div className="col-8">
                    <div className="d-flex align-items-center justify-content-start gap-2">
                        <UserImage guid={user.guid} size={64} border={true} />
                        <h6>{user.displayName}</h6>
                    </div>
                </div>
                <div className="col text-center">
                    <h4>{eventsCount}</h4> <small>eventi critici</small>
                </div>
            </div>


        </div>

    </div>


}